import caseStudy1 from "../assets/images/case-study1.png";
import caseStudy2 from "../assets/images/case-study2.png";
import caseStudy3 from "../assets/images/case-study3.png";
import caseStudy4 from "../assets/images/case-study4.png";
import enterprise_story_1 from "../assets/images/enterprise_story_1.png";
import enterprise_story_2 from "../assets/images/enterprise_story_2.png";
import enterprise_story_3 from "../assets/images/enterprise_story_3.png";
// import solutionbrief_1 from "../assets/pdfs/solutionbrief_1.pdf";
import casestudies_img_1 from "../assets/caseStudiesImages/casestudies_img_1.png";
import casestudies_img_2 from "../assets/caseStudiesImages/casestudies_img_2.png";
import casestudies_img_3 from "../assets/caseStudiesImages/casestudies_img_3.png";
import casestudies_img_4 from "../assets/caseStudiesImages/casestudies_img_4.png";
import casestudies_img_5 from "../assets/caseStudiesImages/casestudies_img_5.png";
import casestudies_img_6 from "../assets/caseStudiesImages/casestudies_img_6.png";
import casestudies_img_7 from "../assets/caseStudiesImages/casestudies_img_7.png";
import casestudies_img_8 from "../assets/caseStudiesImages/casestudies_img_8.png";
import casestudies_img_9 from "../assets/caseStudiesImages/casestudies_img_9.png";
import casestudies_img_10 from "../assets/caseStudiesImages/casestudies_img_10.png";
import casestudies_img_11 from "../assets/caseStudiesImages/casestudies_img_11.png";
import casestudies_img_12 from "../assets/caseStudiesImages/casestudies_img_12.png";
import casestudies_img_13 from "../assets/caseStudiesImages/casestudies_img_13.png";
import casestudies_img_14 from "../assets/caseStudiesImages/casestudies_img_14.png";
import casestudies_img_15 from "../assets/caseStudiesImages/casestudies_img_15.png";
import casestudies_img_16 from "../assets/caseStudiesImages/casestudies_img_16.png";
import casestudies_img_17 from "../assets/caseStudiesImages/casestudies_img_17.png";
import casestudies_img_18 from "../assets/caseStudiesImages/casestudies_img_18.png";
import casestudies_img_19 from "../assets/caseStudiesImages/casestudies_img_19.png";
import casestudies_img_20 from "../assets/caseStudiesImages/casestudies_img_20.png";
import casestudies_img_21 from "../assets/caseStudiesImages/casestudies_img_21.png";
import casestudies_img_22 from "../assets/caseStudiesImages/casestudies_img_22.png";
import casestudies_img_23 from "../assets/caseStudiesImages/casestudies_img_23.png";
import jpalmer from "../assets/caseStudiesImages/jpalmer.png";
import los from "../assets/caseStudiesImages/los.png";

import csimage from "../assets/images/csimage.png";
import csimage1 from "../assets/images/csimage1.png";
import csimage2 from "../assets/images/csimage2.png";
import implement from "../assets/images/implement.png";
import cicd from "../assets/images/cicd.png";
import cicdimp from "../assets/images/cicdimp.png";
import cicdasi from "../assets/images/cicdasi.png";
import asi from "../assets/images/asi.png";
import migcloud from "../assets/images/migcloud.png";
import redshift from "../assets/images/redshift.png";
import dlu from "../assets/images/dlu.png";
import lex from "../assets/images/lex.png";


export const caseStudies = [
  {
    id: 1,
    image: casestudies_img_22,
    title: "Automating Financial Spreading for Faster Credit Risk Assessment",
    description:
      "Leveraging advanced AI and machine learning technologies to automate the extraction and mapping of financial data.",
      link: "resources/case-studies/Fast-Forward-from-Financial-Statements-to-Lending-Loans.pdf",
    },
  {
    id: 2,
    image: casestudies_img_15,
    title: "Accelerating Tax Form Processing with Intelligent Document Extraction",
    description:
      "A financial services firm reduced processing time and improved accuracy by automating data extraction from US tax forms using a custom solution built on AWS Textract.",
      link: "resources/case-studies/Empowering-Structured-Information-Extraction-from-Tax-Forms.pdf",
    },
  {
    id: 3,
    image: casestudies_img_19,
    title:
    "Driving Data-Driven Decisions with Redshift: A Cloud-Native Migration Journey",
  description:
    "Idexcel implemented an automated, scalable, and cost-effective data pipeline on AWS—enabling faster insights, better reporting, and seamless analytics at scale.",
  link: "resources/case-studies/DLU-CaseStudy.pdf",
  },
  {
    id: 4,
    image: casestudies_img_12,
    title: "Modernizing Legacy Lending with Scalable Cloud Transformation",
    description:
      "Re-architecting a monolithic application into a resilient, cloud-native ecosystem to boost performance, reduce costs, and accelerate innovation.",
    link: "resources/case-studies/migrate-to-cloud-leading-us-based-nbfc.pdf",
  },
];

export const data_analytics_caseStudies = [
  {
    id: 1,
    image: dlu,
    title: "Driving Data-Driven Decisions with Redshift: A Cloud-Native Migration Journey",
    description:
      "Idexcel implemented an automated, scalable, and cost-effective data pipeline on AWS—enabling faster insights, better reporting, and seamless analytics at scale.",
    link: "resources/case-studies/DLU-CaseStudy.pdf",
  },
  {
    id: 2,
    image: redshift,
    title: "Optimizing Data Management and Scalability with AWS Redshift",
    description:
      "Streamlining data processing and enhancing decision-making capabilities through a fully automated, scalable cloud data warehousing solution.",
    link: "resources/case-studies/Redshift-Migration-for-Loan-Origination-System.pdf",
  },
  {
    id: 3,
    image: lex,
    title: "Empowering Fintech Reporting with Conversational AI: A Chatbot-Driven Approach",
    description:
      "An AWS Lex-powered chatbot that turned time-consuming reporting into real-time insights and actions.",
    link: "resources/case-studies/Amazon-Lex-Case-Study.pdf",
  },
]

export const solution_services_caseStudies = [
  {
    id: 1,
    image: implement,
    title: "Automating DevOps for Faster, Secure, and Quality Software Releases",
    description:
      "Enhancing release cycles, improving deployment speed, and reducing defects with a fully automated DevOps pipeline.",
    link: "resources/case-studies/implementing-devops-for-a-leading-financial-software-solutions-company.pdf",
  },
  {
    id: 2,
    image: cicd,
    title: "Accelerating Software Delivery with DevOps Automation",
    description:
      "Implementing a fully automated CI/CD pipeline reducing defects by 30% and increasing release frequency by 40% within just three months.",
    link: "resources/case-studies/implementing-ci-cd-pipeline-for-global-data-management-platform-leader.pdf",
  },
  {
    id: 3,
    image: cicdimp,
    title: "Accelerating Loan Processing with a Secure, Scalable Cloud-Native Platform",
    description:
      "Reducing approval time, cutting storage costs, and streamlining workflows with a cloud-first, automation-driven loan processing solution.",
    link: "resources/case-studies/ci-cd-implementation-for-a-leading-mortgage-lender.pdf",
  },
]

export const enterprise_caseStudies = [
  {
    id: 1,
    image: enterprise_story_1 ,
    title: "Automating Financial Spreading for Faster Credit Risk Assessment",
    description:
      "Leveraging advanced AI and machine learning technologies to automate the extraction and mapping of financial data.",
    link: "resources/case-studies/Fast-Forward-from-Financial-Statements-to-Lending-Loans.pdf",
  },
  {
    id: 2,
    image: enterprise_story_2,
    title: "Accelerating Tax Form Processing with Intelligent Document Extraction",
    description:
      "A financial services firm enhanced efficiency and accuracy by automating data extraction from US tax forms using AWS Textract.",
    link: "resources/case-studies/Empowering-Structured-Information-Extraction-from-Tax-Forms.pdf",
  },
  {
    id: 3,
    image: enterprise_story_3,
    title: "Transforming AP/AR Statement Processing for ABL Lending with Intelligent Automation",
    description:
      "A tailored ML solution enabled faster onboarding and high-accuracy data extraction for a leading lending software provider.",
    link: "resources/case-studies/AP-AR-Statement-Data-Extraction.pdf",
  },
]
export const cloud_service_caseStudies = [
  {
    id: 1,
    image: cicdasi,
    title: "Accelerating Loan Processing with a Secure, Scalable Cloud-Native Platform",
    link: "resources/case-studies/ci-cd-implementation-for-a-leading-mortgage-lender.pdf",
  },
  {
    id: 2,
    image: asi,
    title: "Building a Scalable and Automated AWS Environment for ASI DAIS",
    link: "resources/case-studies/ASI-Data-Analytics-Information-System.pdf",
  },
  {
    id: 3,
    image: migcloud,
    title: "Modernizing Legacy Lending with Scalable Cloud Transformation",
    link: "resources/case-studies/migrate-to-cloud-leading-us-based-nbfc.pdf",
  },
];

export const CustomerStories = [
    {
    id: 1,
    image: jpalmer,
    title: "JPalmer Excel Automation: AI-Powered Data Processing with Amazon Bedrock",
    description:
      "JPalmer implemented an AI-powered Excel automation system leveraging Amazon Bedrock, enabling intelligent data extraction, mapping, and transformation at scale.",
    link: "resources/case-studies/jpalmer-excel-automation-ai-powered-data-processing-with-amazon-bedrock.pdf",
  },
  {
    id: 2,
    image: los,
    title: "GenAI-Powered Financial Document Processing: Cync LOS Case Study",
    description:
      "NDS Systems integrated AWS Generative AI into Cync LOS, automating financial document processing and accelerating commercial loan origination efficiency.",
    link: "resources/case-studies/genai-powered-financial-document-processing-cync-los-case-study.pdf",
  },
  {
    id: 1,
    image: casestudies_img_1,
    title: "Building a Scalable and Automated AWS Environment for ASI DAIS ",
    description:
      "A strategic collaboration between Idexcel and ASI to design a fully automated, secure, and reusable cloud infrastructure tailored to DAIS application needs.",
    link: "resources/case-studies/ASI-Data-Analytics-Information-System.pdf",
  },
  {
    id: 2,
    image: casestudies_img_2,
    title: "Modernizing a Legacy ERP System Through Cloud Migration",
    description:
      "A seamless AWS migration reduced costs, improved scalability, and enhanced performance for a legacy Oracle-based ERP system.",
    link: "resources/case-studies/on-premises-to-cloud-migration-for-leading-erp-solutions-providers.pdf ",
  },
  {
    id: 3,
    image: casestudies_img_3,
    title: "Optimizing Performance and Scalability Through Cloud Migration ",
    description:
      "Boosting performance, scalability, and cost-efficiency through cloud migration, enabling faster data access and seamless management.",
    link: "resources/case-studies/on-premises-to-cloud-migration-for-social-welfare-organization.pdf",
  },
  // {
  //   id: 4,
  //   image: casestudies_img_4,
  //   title:
  //     "Infrastructure Implementation for Regulatory Management Software Provider",
  //   description:
  //     "RIMSYS provides regulatory management software for medical device manufacturers.",
  //   link:   "resources/case-studies/infrastructure-implementation-for-regulatory-management-software-provider.pdf",
  // },
  {
    id: 4,
    image: casestudies_img_5,
    title:
      "Automating DevOps for Faster, Secure, and Quality Software Releases",
    description:
      "Enhancing release cycles, improving deployment speed, and reducing defects with a fully automated DevOps pipeline.",
    link: "resources/case-studies/implementing-devops-for-a-leading-financial-software-solutions-company.pdf",
  },
  {
    id: 5,
    image: casestudies_img_6,
    title:
      "Accelerating Software Delivery with DevOps Automation",
    description:
      "Implementing a fully automated CI/CD pipeline reducing defects by 30% and increasing release frequency by 40% within just three months.",
    link: "resources/case-studies/implementing-ci-cd-pipeline-for-global-data-management-platform-leader.pdf",
  },
  {
    id: 6,
    image: casestudies_img_7,
    title: "Accelerating Loan Processing with a Secure, Scalable Cloud-Native Platform",
    description:
      "Reducing approval time, cutting storage costs, and streamlining workflows with a cloud-first, automation-driven loan processing solution.",
    link: "resources/case-studies/ci-cd-implementation-for-a-leading-mortgage-lender.pdf",
  },
  {
    id: 7,
    image: casestudies_img_8,
    title: "Standardizing CI/CD Pipelines to Accelerate Deployment Across Departments",
    description:
      "Idexcel partnered with a leading financial services provider deliver a scalable CI/CD pipeline within six months.",
    link: "resources/case-studies/devops-implementation-for-a-leading-financial-corporation.pdf",
  },
  {
    id: 8,
    image: casestudies_img_9,
    title: "Seamless Cloud Migration of Single Sign-On with a Scalable, Serverless Architecture",
    description:
      "Idexcel enabled secure cloud migration of SSO with high availability, reduced costs, and streamlined CI/CD.",
    link: "resources/case-studies/Re-architecting-and-cloud-migration.pdf",
  },
  {
    id: 9,
    image: casestudies_img_10,
    title: "Rehosting Oracle Workload on Windows EC2",
    description:
      "Reducing operational costs, enabling scalability, and accelerating platform upgrades with a cloud-first migration strategy.",
    link: "resources/case-studies/rehosting-oracle-workload-on-windows-ec2.pdf",
  },
  {
    id: 10,
    image: casestudies_img_11,
    title: "Accelerating Loan Processing with a Cloud-Native, Scalable Mortgage Platform",
    description:
      "Delivered in just 9 months, the AWS-based solution cut process time by 50% and storage costs by 85%.",
    link: "resources/case-studies/application-replacement-and-migration-to-ec2.pdf",
  },
  {
    id: 11,
    image: casestudies_img_12,
    title: "Modernizing Legacy Lending with Scalable Cloud Transformation",
    description:
      "Re-architecting a monolithic application into a resilient, cloud-native ecosystem to boost performance, reduce costs, and accelerate innovation.",
    link: "resources/case-studies/migrate-to-cloud-leading-us-based-nbfc.pdf",
  },
  {
    id: 12,
    image: casestudies_img_13,
    title: "Transforming AP/AR Statement Processing for ABL Lending with Intelligent Automation",
    description:
      "A tailored ML solution enabled faster onboarding and high-accuracy data extraction for a leading lending software provider.",
    link: "resources/case-studies/AP-AR-Statement-Data-Extraction.pdf",
  },
  {
    id: 13,
    image: casestudies_img_14,
    title: "Automating Document Redaction at Scale for Data Privacy Compliance",
    description:
      "An AI-powered redaction tool built on AWS to help financial institutions protect sensitive data faster, smarter, and at scale.",
    link: "resources/case-studies/Fast-and-Secure-Data-Redaction.pdf",
  },
  {
    id: 14,
    image: casestudies_img_15,
    title: "Accelerating Tax Form Processing with Intelligent Document Extraction",
    description:
      "A financial services firm reduced processing time and improved accuracy by automating data extraction from US tax forms using a custom solution built on AWS Textract.",
    link: "resources/case-studies/Empowering-Structured-Information-Extraction-from-Tax-Forms.pdf",
  },
  // {
  //   id: 16,
  //   image: casestudies_img_16,
  //   title: "Total System Makeover: Designing a Secure & Scalable Solution",
  //   description:
  //     "Rybbon is a digital gifting platform takes the pain and costs out of managing e-gifts, rewards, and incentives with.",
  //   link: "resources/case-studies/Total-System-Makeover-Designing-a-Secure-and-Scalable-Solution.pdf",
  // },
  // {
  //   id: 16,
  //   image: casestudies_img_17,
  //   title: "Invoice Creation and Submission - Finance",
  //   description:
  //     "Our client provides staﬀ augmentation services for one of its customers and their resources deployed in several locations and various.",
  //   link: "resources/case-studies/Invoice-Creation-and-Submission-Finance.pdf",
  // },
  {
    id: 15,
    image: casestudies_img_18,
    title: "Empowering Fintech Reporting with Conversational AI: A Chatbot-Driven Approach",
    description:
      "An AWS Lex-powered chatbot that turned time-consuming reporting into real-time insights and actions.",
    link: "resources/case-studies/Amazon-Lex-Case-Study.pdf",
  },
  {
    id: 16,
    image: casestudies_img_19,
    title:
      "Driving Data-Driven Decisions with Redshift: A Cloud-Native Migration Journey",
    description:
      "Idexcel implemented an automated, scalable, and cost-effective data pipeline on AWS—enabling faster insights, better reporting, and seamless analytics at scale.",
    link: "resources/case-studies/DLU-CaseStudy.pdf",
  },
  {
    id: 17,
    image: casestudies_img_20,
    title: "Optimizing Data Management and Scalability with AWS Redshift",
    description:
      "Streamlining data processing and enhancing decision-making capabilities through a fully automated, scalable cloud data warehousing solution.",
    link: "resources/case-studies/Redshift-Migration-for-Loan-Origination-System.pdf",
  },
  // {
  //   id: 20,
  //   image: casestudies_img_21,
  //   title: "Automated File Conversion Tool",
  //   description:
  //     "Cync Application Suite provides a diverse collection of financial software solutions that covers a vast range of.",
  //   link: "resources/case-studies/Automation-Tool-Case-Study.pdf",
  // },
  {
    id: 18,
    image: casestudies_img_22,
    title: "Automating Financial Spreading for Faster Credit Risk Assessment",
    description:
      "Leveraging advanced AI and machine learning technologies to automate the extraction and mapping of financial data.",
    link: "resources/case-studies/Fast-Forward-from-Financial-Statements-to-Lending-Loans.pdf",
  },
  {
    id: 19,
    image: casestudies_img_23,
    title: "Optimizing Data Migration to AWS: A Seamless Transition",
    description:
      "Idexcel facilitated a smooth migration to AWS, enhancing performance, scalability, and cost savings while ensuring secure, accessible data.",
    link: "resources/case-studies/Public-ClickStream-Case-Study.pdf",
  },
];

export const solutionBriefs = [
  {
    id: 1,
    image: caseStudy1,
    title: "CLOUDTRAIL LOGS DASHBOARDS",
    description:
      "Much like a living organism with complex structures in place and processes occurring, an IT ecosystem has an immense amount ",
    link: "resources/case-studies/CLOUDTRAIL-LOGS-DASHBOARDS-SOLUTION-BRIEF-25.pdf",
  },
  {
    id: 2,
    image: caseStudy2,
    title: "InferIQ",
    description:
      "Download the InferIQ Solution brief and learn more about how InferIQ solves the major data extraction challenges and common problems & bottlenecks.",
    link: "https://www.inferiq.ai/solution-brief/",
  },
];
